module.exports = __webpack_public_path__ + "static/media/2Specialties.88df0544.svg";